import script from "./luma.vue?vue&type=script&setup=true&lang=js"
export * from "./luma.vue?vue&type=script&setup=true&lang=js"

import "./luma.vue?vue&type=style&index=0&id=27fa0034&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.4_vue@3.5.4_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27fa0034"]])

export default __exports__